module.exports = __webpack_public_path__ + "img/Chat.f2bec24b.svg";